module.exports = __webpack_public_path__ + "static/media/ticket.b0a6c308.svg";